module.exports = __webpack_public_path__ + "svg/flags/Bonaire, Sint Eustatius and Saba.svg";